import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { getIpDetails } from './other';

export interface IpDataState {
  ip: string | null;
}

interface IpDataResponseProp {
  status: string;
  isFetching: boolean;
  payload: IpDataState | null;
}

// Define the initial state using that type
const initialState: IpDataResponseProp = {
  status: 'init',
  payload: null,
  isFetching: false,
};

export const fetchIpDetails = createAsyncThunk('get/ip-data', async () => {
  return await getIpDetails();
});

// Then, handle actions in your reducers:
const MainScreenSlice = createSlice({
  name: 'getIpDetails',
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchIpDetails.pending, (state) => {
        state.status = 'pending';
        state.isFetching = true;
      })
      .addCase(fetchIpDetails.fulfilled, (state, action) => {
        // Add user to the state array
        state.status = 'success';
        state.isFetching = false;
        state.payload = action.payload;
      })
      .addCase(fetchIpDetails.rejected, (state) => {
        state.status = 'failed';
        state.isFetching = false;
      });
  },
});

export const getIpDetailsSelector = (state: RootState) => state.ipResource;
export default MainScreenSlice.reducer;
